<template>
  <input
    v-model="time"
    type="time"
    :disabled="is_disabled"
    :style="`cursor: ${is_disabled ? 'default' : 'pointer'};`"
    @blur="changeTime()"
    @keyup.enter="changeTime()"
  >
</template>
<script>
  export default {
    props: [
        'min_time',
        'max_time',
        'value',
        'is_disabled',
    ],

    data () {
      return {
        time: this.convertSecondsToTime(this.value),
      }
    },

    methods: {
      changeTime() {
        let arr = this.time.split(':');
        let seconds = this.convertTimeToSeconds(arr, 0, 0, 1);
        if(seconds < this.min_time){
          this.time = this.convertSecondsToTime(this.min_time)
          this.$emit('change', this.min_time)
        } else if ( seconds > this.max_time) {
          this.time = this.convertSecondsToTime(this.max_time)
          this.$emit('change', this.max_time)
        } else {
          this.$emit('change', seconds)
        }
      },

      convertSecondsToTime(seconds) {
          return new Date(seconds * 1000).toISOString().slice(11, 16);
      },

      convertTimeToSeconds(arr, i, seconds, time_index) {
        if(arr.length === i){
          return seconds;
        } else {
          seconds += arr[arr.length - i - 1] * Math.pow(60, time_index)
          return this.convertTimeToSeconds(arr, ++i, seconds, ++time_index)
        }
      }
    },

    computed: {

    }
  }
</script>
<style>

</style>
